import React, { useEffect, useState } from "react";
import dataHubIcon from "../../assets/icons/dataHub-icon.svg";
import { useSelector, useDispatch } from "react-redux";
import OrganizationSearchBaseComponent from "../../components/OrganizationSearchBaseComponent";
import GTM from "../../GTM";
import { setReportDetails } from "../../slices/viewReportSlice";
import { useParams } from "react-router-dom";
import {
    getPageReferrerTitle,
    getSelectedIsfOrganizationIds,
} from "../../utils/helpers";
import PropTypes from "prop-types";
import { useLazyGetReportDetailsQuery } from "../../slices/saveReportViewSlice";
import { DATAVIEWTYPE } from "../../constants";

function ViewMyInsights(props) {
    const { setOrganizationsSelected } = props;
    const { orgid } = useParams();
    const { user } = useSelector((state) => state.auth);
    const { config } = useSelector((state) => state.app);
    const dispatch = useDispatch();
    const {
        parentOrganizations: organizations,
        organizations: allOrganizations,
        policies,
    } = useSelector((state) => state.userDetails);
    const {
        selectedOrganizations: userSelectedOrganizations,
        selectedOrganizationsId: id,
        totalParentOrganizations,
        organizationsCount,
    } = useSelector((state) => state.organizations);

    const {
        selectedOrganizationsReports: userSelectedOrganizationReports,
        selectedOrganizationsIdReports: reportId,
        selectedRelatedOrganizationsForReports: selectedRelatedOrganizations,
    } = useSelector((state) => state.reportOrganization);

    let previousUrls = props.previousUrl;
    let page_referrer = previousUrls[previousUrls.length - 1];

    const gtm = new GTM(null);

    const page_referrer_url =
        page_referrer === "/login"
            ? `${config.REACT_APP_ISERVICES}:81/LanAuthentication`
            : `${config.REACT_APP_BASE_URL}${page_referrer}`;

    const page_referrer_title = getPageReferrerTitle(
        page_referrer_url,
        user,
        dispatch
    );

    useEffect(() => {
        const userName = "";
        const userId = user ? user.userId : "";
        const userEmail = user.userEmail || "";
        const userRole = user.isUserInternal ? "internal" : "external";

        gtm.PageView(
            "dashBoards",
            userName,
            userId,
            userRole,
            window.location.href,
            `${config.REACT_APP_BASE_URL}${page_referrer}`,
            page_referrer_title,
            orgid,
            userEmail
        );
    }, [20000]);

    const [selectedOrganization, setSelectedRelatedOrganizations] = useState(
        []
    );
    const { organizationPreference = [] } = useSelector(
        (state) => state.preferenceSlice
    );

    // OrganizationSearchBaseComponent reports a single org as an object (clearing sends []),
    // but Dashboard's displayReportView gates on .length - normalize so one org counts as selected.
    const organizationSelected = (value) => {
        if (Array.isArray(value)) {
            setOrganizationsSelected(value);
            return;
        }

        setOrganizationsSelected(value ? [value] : []);
    };

    const handleSelectedRelatedOrganizations = (selectedOrgs) => {
        setSelectedRelatedOrganizations(selectedOrgs);
    };

    const { selectedIsfOrganizationIds, organizationGroupId } =
        getSelectedIsfOrganizationIds(
            userSelectedOrganizationReports,
            reportId,
            selectedRelatedOrganizations,
            totalParentOrganizations
        );

    const [getReportDetails, { data: reportDetailsData }] =
        useLazyGetReportDetailsQuery();

    useEffect(() => {
        if (reportDetailsData) {
            dispatch(setReportDetails(reportDetailsData));
        }
    }, [reportDetailsData]);

    const reportDetailsParams = {
        isfUserId: user.userId,
        dataViewType: DATAVIEWTYPE,
        selectedIsfOrganizationIds: selectedIsfOrganizationIds,
    };

    if (organizationGroupId) {
        reportDetailsParams.organizationGroupId = organizationGroupId;
    }

    useEffect(() => {
        if (organizations.length === 1) {
            getReportDetails(reportDetailsParams);
        }
    }, [organizations.length, JSON.stringify(selectedIsfOrganizationIds)]);

    return (
        <div className="section-card view-selection-page">
            <div
                className="d-flex header"
                style={{ alignItems: "center", gap: 8 }}
            >
                <img className="icon" src={dataHubIcon} alt="" />
                <h1 className="section-heading mb-0p">Dashboards</h1>
                {organizations.length > 1 ? (
                    ""
                ) : (
                    <>
                        <div className="vr"></div>
                        <label className="sub-header">
                            {userSelectedOrganizations[id]?.related[0]
                                ?.ORGANIZATIONGROUPNAME
                                ? userSelectedOrganizations[id]?.related[0]
                                      ?.ORGANIZATIONGROUPNAME
                                : userSelectedOrganizations[id]?.organization
                                      ?.ORGNIZATIONNAME}
                        </label>
                    </>
                )}

                {userSelectedOrganizations[id]?.related.length > 1 &&
                totalParentOrganizations === 1 ? (
                    <>
                        <div className="vr"></div>
                        <label className="sub-header">
                            {userSelectedOrganizations[id]?.related[0]
                                .ORGANIZATIONGROUPNAME
                                ? userSelectedOrganizations[id]?.related[0]
                                      .ORGANIZATIONGROUPNAME
                                : userSelectedOrganizations[id]?.organization
                                      ?.ORGNIZATIONNAME}
                        </label>
                    </>
                ) : (
                    ""
                )}
                {userSelectedOrganizationReports[reportId]?.related?.length >
                    0 &&
                    totalParentOrganizations > 1 && (
                        <>
                            <div
                                className="vr text-color"
                                style={{ width: 2 }}
                            ></div>
                            <h1
                                className="sub-heading-disabled"
                                style={{
                                    paddingBottom: 0,
                                    fontWeight: 600,
                                    fontSize: "1rem",
                                    marginBottom: "0px",
                                }}
                            >
                                {
                                    userSelectedOrganizationReports[reportId]
                                        ?.related[0].ORGANIZATIONGROUPNAME
                                }
                            </h1>
                        </>
                    )}
            </div>

            {(organizations.length > 1 ||
                userSelectedOrganizations[id]?.related.length > 0) && (
                <div style={{ marginTop: 20 }}>
                    <OrganizationSearchBaseComponent
                        organizations={organizations}
                        allOrganizations={allOrganizations}
                        policies={policies}
                        totalParentOrganizations={totalParentOrganizations}
                        organizationPreference={organizationPreference}
                        userSelectedOrganizations={userSelectedOrganizations}
                        organizationsCount={organizationsCount}
                        organizationSelected={organizationSelected}
                        onSelectedRelatedOrganizationsChange={
                            handleSelectedRelatedOrganizations
                        }
                        clearButtonText="Clear selection"
                        myInsights={true}
                    />
                </div>
            )}
        </div>
    );
}

ViewMyInsights.propTypes = {
    previousUrl: PropTypes.array.isRequired,
    setOrganizationsSelected: PropTypes.func,
};

export default ViewMyInsights;
